export const loadSvgImages = () => {
  const context = require.context(`../img/picture`, true, /\.(png|svg)$/);
  return context.keys().map(key => context(key));
};